module.exports = function (router) {
  router.beforeEach(function (transition) {
    if (transition.to.auth) {
      //
    }

    transition.next()
  })
}



/** WEBPACK FOOTER **
 ** ./src/http/middlewares.js
 **/